(function () {
  'use strict';

  /**
   * Adds decimal adjustment of a number, as described at MDN's Math.round() documentation page:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
   * 
   * Extends Math.round, Math.floor, and Math.ceil functions to work with floating point numbers
   * by taking an optional 'prec' parameter (integer value).  All 3 extended function make use of
   * the decimalAdjust function defined below.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} prec  The number of decimal places considered; a negative value will adjust to powers of 10
   * @returns {Number} The adjusted value.
   */
  Number.isInteger = Number.isInteger || function (value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
  };
  function decimalAdjust(type, value, prec) {
    // If prec is undefined or zero...
    if (typeof prec === 'undefined' || +prec === 0) {
      return Math[type](value);
    }
    value = +value;
    prec = +prec;
    // If the value is not a number or prec is not an integer...
    if (isNaN(value) || !(typeof prec === 'number' && prec % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] + prec : prec)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] - prec : -prec));
  }

  // Decimal round
  /*
   Math.round(55.55, 1);    // 55.6
   Math.round(55.549, 1);   // 55.5
   Math.round(55, -1);      // 60
   Math.round(54.9, -1);    // 50
   Math.round(-55.55, 1);   // -55.5
   Math.round(-55.551, 1);  // -55.6
   Math.round(-55, -1);     // -50
   Math.round(-55.1, -1);   // -60
   Math.round(1.005, 2);    // 1.01 -- compare this with Math.round(1.005*100)/100 = 1
   */
  if (!Math.round10) {
    Math.round_int = Math.round;
    Math.round10 = function (value, prec) {
      return decimalAdjust('round', value, prec);
    };
    Math.round = function (value, prec) {
      return Number.isInteger(prec) ? Math.round10(value, prec) : Math.round_int(value);
    };
  }
  // Decimal floor
  /*
   Math.floor(55.59, 1);    // 55.5
   Math.floor(59, -1);      // 50
   Math.floor(-55.51, 1);   // -55.6
   Math.floor(-51, -1);     // -60
   */
  if (!Math.floor10) {
    Math.floor_int = Math.floor;
    Math.floor10 = function (value, prec) {
      return decimalAdjust('floor', value, prec);
    };
    Math.floor = function (value, prec) {
      return Number.isInteger(prec) ? Math.floor10(value, prec) : Math.floor_int(value);
    };
  }
  // Decimal ceil
  /*
   Math.ceil(55.51, 1);     // 55.6
   Math.ceil(51, -1);       // 60
   Math.ceil(-55.59, 1);    // -55.5
   Math.ceil(-59, -1);      // -50
   */
  if (!Math.ceil10) {
    Math.ceil_int = Math.ceil;
    Math.ceil10 = function (value, prec) {
      return decimalAdjust('ceil', value, prec);
    };
    Math.ceil = function (value, prec) {
      return Number.isInteger(prec) ? Math.ceil10(value, prec) : Math.ceil_int(value);
    };
  }
})();
